// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__-NCPa","empty":"ModalGraph_empty__2VbTr"};